/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Lavora con noi',
    titleMeta: 'Carriere — Offerte di lavoro | CamDiab',
    descriptionMeta: 'Scopri le opportunità di carriera in CamDiab. Unisciti al nostro team per migliorare la vita con il diabete.',
    keywords: 'CamDiab carriere, lavoro, offerte, diabete',
    localeMeta: 'it_it',

    bannerTitle: 'Offerte di lavoro',
    bannerSubtitle: 'Vuoi unirti al nostro team?',
    heroNote: 'Tutte le offerte sono pubblicate in inglese.',

    introBody:
        'Se cerchi una nuova sfida e vuoi contribuire a un cambiamento significativo, ci piacerebbe sentirti. Investiamo nelle nostre persone, il cuore di CamDiab. I benefici per i dipendenti sono pensati per far emergere il meglio da tutti, e includono:',

    benefitsTitle: '',
    benefits: [
        'Contributo pensionistico aziendale generoso',
        'Assicurazione sanitaria integrativa',
        'Assicurazione sulla vita',
        'Bonus annuale discrezionale',
        '29 giorni di ferie annuali più 8 giorni festivi',
        'Opportunità di lavorare su tecnologie all’avanguardia che possono trasformare la gestione del diabete e migliorare gli esiti per i pazienti',
        'Ambiente di lavoro collaborativo e dinamico',
        'Retribuzione e pacchetto benefit competitivi, con opportunità di sviluppo professionale e carriera',
    ],

    outroHtml:
        'Se sei appassionato di un impatto reale nel mondo reale, ci piacerebbe sentirti:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Nessuna posizione aperta',
    emptyVacancyBody:
        'Potremmo non assumere in questo momento, ma CamDiab sta crescendo e ci interessa sempre sentire persone appassionate a migliorare la vita con il diabete. Torna a trovarci.',

    applyLabel: 'Candidati ora',
};
